import React from "react";
import profile from "../../assets/images/profile/DuumyProfileImage.png";  

function RandDTeam() {
  return (
    <div>
      <section className="contact-page rpy-100 py-50">
        <div className="container">
          <div className="">
            <h2 className="text-center py-20">R&D Team</h2>
            {/* <p className='text-center'>
            We have a dedicated team focused on research and development
         </p> */}
            <div className="row">
              <div className="col-lg-5">
                <div className="team-profile-image rmb-45 wow fadeInLeft delay-0-2s">
                  <div className=" mb-10 profile-name">
                    <h2 className="name blue-text">Col TJ Zacharia, SM</h2>
                    <span className="designation">Head, R&D </span>
                  </div>
                  <div className="team-profileimg">
                    <img
                      className="team-profile"
                      src={profile}
                      alt="Team Profile"
                    />
                  </div>
                 
                </div>
              </div>
              <div className="col-lg-7"></div>
            </div>
            <div className="pt-40">
               <h2 className="text-center py-20">Team Members</h2>
            <div className="row g-2 ">
  <div className="col-lg-4 p-2">
    <div className="profile-card text-center p-4 feature-item-two  delay-0-8s bg-white h-100">
      <img src={profile} alt="Profile" className="profile-img mb-3" />
      <h5 className="name blue-text">Name</h5>
      <p className="designation">Designation</p>
    </div>
  </div>

  <div className="col-lg-4 p-2">
    <div className="profile-card text-center p-4 feature-item-two  delay-0-8s bg-white h-100">
      <img src={profile} alt="Profile" className="profile-img mb-3" />
      <h5 className="name blue-text">Name</h5>
      <p className="designation">Designation</p>
    </div>
  </div>

  <div className="col-lg-4 p-2">
    <div className="profile-card text-center p-4 feature-item-two  delay-0-8s bg-white h-100">
      <img src={profile} alt="Profile" className="profile-img mb-3" />
      <h5 className="name blue-text">Name</h5>
      <p className="designation">Designation</p>
    </div>
  </div>
</div>



                
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default RandDTeam;
